import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHero({ overline, title, subtitle, image, crumbs = [], height = "h-[52vh]" }) {
  return (
    <section data-testid="page-hero" className={`relative ${height} min-h-[380px] w-full overflow-hidden`}>
      <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/45 to-charcoal/25" />
      <div className="relative mx-auto flex h-full max-w-7xl flex-col justify-end px-4 pb-14 sm:px-6">
        {crumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-4 flex flex-wrap items-center gap-1 text-xs text-cream/80">
            <Link to="/" className="hover:text-saffron">Home</Link>
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-1">
                <ChevronRight className="h-3 w-3" />
                {c.to ? <Link to={c.to} className="hover:text-saffron">{c.label}</Link> : <span className="text-cream">{c.label}</span>}
              </span>
            ))}
          </nav>
        )}
        {overline && <div className="overline mb-3 text-gold">{overline}</div>}
        <h1 className="max-w-3xl font-display text-4xl font-bold leading-[1.05] text-cream text-shadow-lg sm:text-5xl lg:text-6xl">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-base leading-relaxed text-cream/85 sm:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionHeading({ overline, title, description, center = false, light = false }) {
  return (
    <div className={`${center ? "mx-auto text-center" : ""} max-w-2xl`}>
      {overline && (
        <div className={`mb-3 flex items-center gap-2 ${center ? "justify-center" : ""}`}>
          <span className="h-1.5 w-1.5 rotate-45 bg-saffron" aria-hidden="true" />
          <span className="overline text-saffron">{overline}</span>
        </div>
      )}
      <h2 className={`font-display text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl ${light ? "text-cream" : "text-charcoal"}`}>{title}</h2>
      {description && <p className={`mt-4 text-base leading-relaxed ${light ? "text-cream/80" : "text-muted-foreground"}`}>{description}</p>}
    </div>
  );
}
